/* Omawild PDP — buy panel behaviour for sections/owv2-product-main.liquid.
   Everything is read from the JSON island the section renders: variants,
   their selling-plan allocation prices and the copy strings. The form it
   drives is an ordinary /cart/add product form. */
(function () {
  'use strict';

  function init(root) {
    if (root.__odp) return;
    root.__odp = true;

    var island = root.querySelector('[data-odp-json]');
    if (!island) return;
    var data;
    try { data = JSON.parse(island.textContent); } catch (e) { return; }

    var variantInput = root.querySelector('[data-odp-variant]');
    var planInput = root.querySelector('[data-odp-plan-input]');
    var qtyInput = root.querySelector('[data-odp-qty-input]');
    var nudge = root.querySelector('[data-odp-nudge]');
    var bar = root.querySelector('[data-odp-bar]');
    var mainImg = root.querySelector('img.odp-gallery__main');

    var state = {
      mode: data.mode,
      planId: data.planId != null ? String(data.planId) : null,
      planName: data.planName,
      qty: 1,
      options: []
    };

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-odp-option]'))
      .filter(function (g) { return !g.hasAttribute('data-odp-plans'); });
    groups.forEach(function (g, i) {
      var on = g.querySelector('[aria-pressed="true"]');
      state.options[i] = on ? on.getAttribute('data-odp-value') : null;
    });

    function findVariant(options) {
      if (data.defaultOnly) return data.variants[0];
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function unitPrice(v) {
      if (state.mode === 'sub' && state.planId && v.plans[state.planId] != null) return v.plans[state.planId];
      return v.price;
    }

    function subPrice(v) {
      return state.planId && v.plans[state.planId] != null ? v.plans[state.planId] : v.price;
    }

    function percent(v) {
      if (!v.price) return 0;
      return Math.round(((v.price - subPrice(v)) / v.price) * 100);
    }

    // Shared with every other custom price display — see assets/ow-money.js.
    function money(c) { return window.owMoney(c); }

    function each(sel, fn) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
    }

    function render() {
      var v = findVariant(state.options);
      var available = !!(v && v.available);

      if (v) variantInput.value = v.id;
      qtyInput.value = state.qty;
      if (planInput) {
        planInput.disabled = state.mode !== 'sub';
        if (state.planId) planInput.value = state.planId;
      }

      // pills: pressed state + strike through values that can't combine into a buyable variant
      groups.forEach(function (g, i) {
        Array.prototype.forEach.call(g.querySelectorAll('[data-odp-value]'), function (btn) {
          var val = btn.getAttribute('data-odp-value');
          btn.setAttribute('aria-pressed', val === state.options[i] ? 'true' : 'false');
          var probe = state.options.slice();
          probe[i] = val;
          var pv = findVariant(probe);
          btn.classList.toggle('is-unavailable', !pv || !pv.available);
        });
      });
      each('[data-odp-mode]', function (btn) {
        if (btn.classList.contains('odp-choice')) {
          btn.setAttribute('aria-pressed', btn.getAttribute('data-odp-mode') === state.mode ? 'true' : 'false');
        }
      });
      each('[data-odp-plan]', function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-odp-plan') === state.planId ? 'true' : 'false');
      });

      if (!v) {
        each('[data-odp-cta]', function (b) { b.disabled = true; b.textContent = data.copy.soldOut; });
        return;
      }

      var total = unitPrice(v) * state.qty;
      var was = 0;
      if (state.mode === 'sub' && subPrice(v) < v.price) was = v.price * state.qty;
      else if (state.mode === 'once' && v.compare > v.price) was = v.compare * state.qty;

      each('[data-odp-price]', function (el) { el.textContent = money(total); });
      each('[data-odp-was]', function (el) { el.textContent = was ? money(was) : ''; });

      var pct = percent(v);
      var suffix = state.mode === 'sub'
        ? (data.multiPlan && state.planName ? state.planName : data.copy.lineSub)
        : data.copy.lineOnce;
      var parts = data.defaultOnly ? [] : v.options.slice();
      if (suffix) parts.push(suffix);
      each('[data-odp-line]', function (el) { el.textContent = parts.join(' · '); });

      var subCopy = root.querySelector('[data-odp-sub-copy]');
      if (subCopy) subCopy.textContent = data.copy.subCopy.replace('[percent]', pct);

      var badge = root.querySelector('[data-odp-badge]');
      if (badge) badge.textContent = state.mode === 'sub' && pct > 0 ? data.copy.badge.replace('[percent]', pct) : '';

      if (nudge) {
        var sub = subPrice(v) * state.qty;
        var saving = v.price * state.qty - sub;
        var showNudge = state.mode === 'once' && saving > 0;
        nudge.hidden = !showNudge;
        if (showNudge) {
          var text = nudge.querySelector('[data-odp-nudge-text]');
          var html = escapeHtml(data.copy.nudge)
            .replace('[price]', '<strong>' + escapeHtml(money(sub)) + '</strong>')
            .replace('[saving]', escapeHtml(money(saving)));
          text.innerHTML = html;
        }
      }

      each('[data-odp-cta]', function (b) {
        b.disabled = !available;
        b.textContent = !available ? data.copy.soldOut : (state.mode === 'sub' ? data.copy.ctaSub : data.copy.ctaOnce);
      });
      root.querySelector('[data-odp-qty-out]').textContent = state.qty;

      if (v.media && mainImg && mainImg.getAttribute('data-variant-src') !== v.media) {
        mainImg.setAttribute('data-variant-src', v.media);
        swapMain(v.media, '', mainImg.alt);
      }
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function swapMain(src, srcset, alt) {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      if (srcset) mainImg.setAttribute('srcset', srcset);
      mainImg.src = src;
      if (alt != null) mainImg.alt = alt;
    }

    // Ordinary /cart/add form, but intercepted: current.available only
    // reflects inventory, not Shopify Markets catalog exclusion, so a
    // variant can render as buyable here and still get rejected by
    // /cart/add for a shopper in a market it isn't published to. Without
    // this, that rejection would fall through to a native form POST and
    // the browser would navigate to Shopify's raw, unstyled error page.
    var formEl = root.querySelector('[data-odp-form]');
    var errorBox = root.querySelector('[data-odp-error]');
    if (formEl && !formEl.__odpSubmit) {
      formEl.__odpSubmit = true;
      formEl.addEventListener('submit', function (e) {
        var btn = formEl.querySelector('[data-odp-cta]');
        if (btn && btn.disabled) return;
        e.preventDefault();

        if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
        each('[data-odp-cta]', function (b) { b.disabled = true; });

        var routes = (window.theme && window.theme.routes) || {};
        var addUrl = routes.cart_add_url || '/cart/add';
        var cartUrl = routes.cart_url || '/cart';

        fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(formEl)
        })
          .then(function (res) {
            return res.text().then(function (text) {
              var parsed;
              try { parsed = JSON.parse(text); }
              catch (parseErr) {
                // The response wasn't JSON at all — most commonly the storefront
                // redirected somewhere (a password gate, a login wall) instead of
                // handling /cart/add. Logged so this is diagnosable from the
                // console instead of just "nothing happened".
                console.error('[owv2-product] /cart/add returned non-JSON:', res.status, text.slice(0, 300));
                throw parseErr;
              }
              return { ok: res.ok, body: parsed };
            });
          })
          .then(function (result) {
            if (!result.ok || result.body.status) {
              var message = (result.body && (result.body.description || result.body.message))
                || "This item can't be added to your cart right now.";
              if (errorBox) { errorBox.textContent = message; errorBox.hidden = false; }
              each('[data-odp-cta]', function (b) { b.disabled = false; });
              return;
            }
            window.location = cartUrl;
          })
          .catch(function (err) {
            console.error('[owv2-product] add-to-cart request failed:', err);
            if (errorBox) {
              errorBox.textContent = "Couldn't reach the cart just now — please refresh the page and try again.";
              errorBox.hidden = false;
            }
            each('[data-odp-cta]', function (b) { b.disabled = false; });
          });
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-odp-value')) {
        var g = t.closest('[data-odp-option]');
        var i = groups.indexOf(g);
        if (i > -1) { state.options[i] = t.getAttribute('data-odp-value'); render(); }
      } else if (t.hasAttribute('data-odp-mode')) {
        state.mode = t.getAttribute('data-odp-mode');
        render();
      } else if (t.hasAttribute('data-odp-plan')) {
        state.planId = t.getAttribute('data-odp-plan');
        state.planName = t.getAttribute('data-odp-plan-name');
        render();
      } else if (t.hasAttribute('data-odp-qty')) {
        state.qty = Math.max(1, Math.min(99, state.qty + parseInt(t.getAttribute('data-odp-qty'), 10)));
        render();
      } else if (t.hasAttribute('data-odp-thumb')) {
        each('[data-odp-thumb]', function (b) { b.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        swapMain(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt'));
      }
    });

    // Sticky bar, same rule on desktop and phones: reveal once the bottom of the
    // origin band has come into view, hide again when scrolling back above it.
    // Without an origin section on the page, fall back to the in-page buy row
    // having scrolled above the viewport.
    if (bar) {
      var barBtn = bar.querySelector('[data-odp-cta]');
      var row = root.querySelector('[data-odp-buyrow]');
      var ticking = false;
      var setBar = function (show) {
        bar.classList.toggle('is-shown', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = show ? 0 : -1;
      };
      var check = function () {
        ticking = false;
        var origin = document.querySelector('[data-odp-origin]');
        if (origin) setBar(origin.getBoundingClientRect().bottom < window.innerHeight);
        else if (row) setBar(row.getBoundingClientRect().bottom < 0);
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      check();
    }

    render();
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-odp]'), init);
  }

  // Click-and-drag scroll for mouse users on the brew card row -- a mouse
  // has no horizontal wheel axis, so overflow-x:auto alone only serves
  // trackpad/touch. Same pattern as sections/od-featured-products.liquid's
  // slider and enableDragScroll() in assets/ow-landing.js, kept local here
  // since .odp-brew lives in owv2-product-detail.liquid, a separate section
  // from the [data-odp] root above that init() operates on.
  function enableDragScroll(wrap) {
    if (!wrap || wrap.__dragScroll) return;
    wrap.__dragScroll = true;
    var isDown = false, startX = 0, startScroll = 0, moved = false;
    wrap.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      wrap.classList.add('is-dragging');
      startX = e.pageX;
      startScroll = wrap.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      isDown = false;
      wrap.classList.remove('is-dragging');
    });
    wrap.addEventListener('mouseleave', function () {
      isDown = false;
      wrap.classList.remove('is-dragging');
    });
    wrap.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      if (Math.abs(e.pageX - startX) > 4) moved = true;
      wrap.scrollLeft = startScroll - (e.pageX - startX);
    });
    // A drag that actually moved the row shouldn't also follow the link
    // underneath the pointer on release -- a brew card with a guide URL
    // renders as an <a>.
    wrap.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function bootBrewDrag(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.odp-brew'), enableDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); bootBrewDrag(); });
  } else {
    boot();
    bootBrewDrag();
  }

  // theme editor: re-init a section after it is re-rendered
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); bootBrewDrag(e.target); });
})();
